"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");
/**
 * @visibleName Grid.Row
 */


exports.GridRow = function (_a) {
  var id = _a.id,
      children = _a.children,
      textAlign = _a.textAlign,
      verticalAlign = _a.verticalAlign,
      gap = _a.gap,
      columnVariate = _a.columnVariate,
      theme = _a.theme,
      overflow = _a.overflow,
      asUl = _a.asUl;
  var Component = asUl ? "ul" : "div";
  return React.createElement(Component, {
    id: id,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "grid-row", CSSPrefix_1.prefixEnumClassNames(textAlign), CSSPrefix_1.prefixEnumClassNames(verticalAlign), gap && CSSPrefix_1.prefixEnumClassNames(gap) + "-gap", columnVariate && CSSPrefix_1.lsgPre + "grid-columnvariate", overflow && CSSPrefix_1.lsgPre + "grid-row__overflow", CSSPrefix_1.prefixEnumClassNames(theme)])
  }, children);
};

exports.GridRow.displayName = "Grid.Row";